import { Link } from "react-router-dom";
import { admin_menus, pm_menus } from "../utils";
import { cn, roles } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const Sidebar = ({ handleClose }: { handleClose?: () => void }) => {
  const [_menus, setMenus] = useState<any>(null);
  const isMobile = useIsMobile();
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  useEffect(() => {
    if (
      loggedInUserData?.roleProjectMap?.some((role: any) => role.roleCode == roles.pm.value)
    ) {
      setMenus(pm_menus);
    } else {
      setMenus(admin_menus);
    }
  }, []);

  return (
    <>
      {_menus?.map((menu: any) => {
        const isActive =
          location.pathname === menu.to ||
          location.pathname.startsWith(menu.to + "/");

        if (menu.children && menu.children.length > 0) {
          return (
            <>
              <Link
                to={menu.to || ""}
                key={menu.title}
                onClick={() => {
                  handleClose?.();
                }}
                className={cn(
                  "flex relative  group transition-all text-[14px] font-[500]",
                  isActive
                    ? "text-secondary"
                    : "text-gray-500 hover:text-secondary",
                  isMobile
                    ? "w-full p-[5px] mb-[10px] flex-row items-start gap-2"
                    : "px-[10px] py-[15px] mb-[10px] flex-col items-center justify-center"
                )}
              >
                {/* Active Indicator */}
                {!isMobile && (
                  <div
                    className={cn(
                      "w-1 h-full bg-secondary absolute rounded-full left-0 transition-opacity",
                      isActive
                        ? "opacity-100"
                        : "opacity-0 group-hover:opacity-100"
                    )}
                  ></div>
                )}
                <menu.icon
                  className={cn(
                    "xl:h-auto xl:w-auto",
                    isActive
                      ? "stroke-secondary text-secondary"
                      : "stroke-g-300 text-g-300 group-hover:text-secondary group-hover:stroke-secondary"
                  )}
                />
                <span
                  className={
                    isActive
                      ? "text-secondary"
                      : "group-hover:text-secondary text-g-300"
                  }
                >
                  {menu.title}
                </span>
              </Link>
              <div
                className={cn(
                  "absolute top-0 bg-white h-full px-[15px] py-[20px] w-[200px] rounded-r-lg transition-all duration-300 ease-in-out",
                  isActive
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 -translate-x-5 pointer-events-none",
                  isMobile ? "left-[180px]" : "left-[117px]"
                )}
              >
                <div className="flex flex-col gap-2">
                  {menu.children.map((child: any) => {
                    const isChildActive =
                      location.pathname === child.to ||
                      location.pathname.startsWith(child.to + "/");
                    return (
                      <Link
                        to={child.to}
                        key={child.title}
                        onClick={handleClose}
                        className={cn(
                          "text-[14px] font-[500] px-2 py-1 rounded-md",
                          isChildActive
                            ? "bg-secondary text-white"
                            : "text-g-300 hover:text-white hover:bg-secondary"
                        )}
                      >
                        {child.title}
                      </Link>
                    );
                  })}
                </div>
              </div>
            </>
          );
        } else if (menu.to) {
          return (
            <Link
              to={menu.to}
              key={menu.title}
              onClick={() => {
                handleClose?.();
              }}
              className={cn(
                "flex relative  group transition-all text-[14px] font-[500]",
                isActive
                  ? "text-secondary"
                  : "text-gray-500 hover:text-secondary",
                isMobile
                  ? "w-full p-[5px] mb-[10px] flex-row items-start gap-2"
                  : "px-[10px] py-[15px] mb-[10px] flex-col items-center justify-center w-[120px]"
              )}
            >
              {/* Active Indicator */}
              {!isMobile && (
                <div
                  className={cn(
                    "w-1 h-full bg-secondary absolute rounded-full left-0 transition-opacity",
                    isActive
                      ? "opacity-100"
                      : "opacity-0 group-hover:opacity-100"
                  )}
                ></div>
              )}
              <menu.icon
                className={cn(
                  "xl:h-auto xl:w-auto",
                  isActive
                    ? "stroke-secondary text-secondary"
                    : "stroke-g-300 text-g-300 group-hover:text-secondary group-hover:stroke-secondary"
                )}
              />
              <span
                className={
                  isActive
                    ? "text-secondary text-center"
                    : "group-hover:text-secondary text-g-300 text-center"
                }
              >
                {menu.title}
              </span>
            </Link>
          );
        }
      })}
    </>
  );
};

export default Sidebar;
